import React from "react";
import TransferBreadCrumb from "../../Components/Transfer/TransferBreadCrumb";
import TransferListings from "../../Components/Transfer/TransferListings";

export default function TransferListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <TransferBreadCrumb />
        <TransferListings />
      </div>
    </React.Fragment>
  );
}
